import { postEmaLead, postEnvisionLead, postFacebookMessengerMessage, postFourthDimensionLead, postIntakeQLead, postNextechLead, postPatientNowLead, postPhoneCall, postReviewLoopText, postTextMessage } from '../../../redux/actions/leadModalActions.js';
import setQuery from '../../../lib/setQuery.js';
import { action } from '../../../lib/actionHelpers.js';
import selectors from '../../../selectors/selectors.js';
import { store } from '../../../redux/lib/configureStore.js';
import formatEmailMessage from '../leadModalChat/chatComposer/lib/formatEmailMessage.js';
import { postEmail, postNote, postTodo } from '../../../redux/actions/leadsActions.js';
import { autoMarkEventAsRead } from '../lib/autoMarkEventAsRead.js';

const triggerActionCompleted = (id, { burstActionId, actionPipelineLeadId, templateId }) => {
  if (burstActionId !== null && actionPipelineLeadId !== null && templateId !== null) {
    action('updatePipelineLeadAction', {
      pipelineLeadId: actionPipelineLeadId,
      actionId: burstActionId,
      id,
      status: 'completed',
    });
  }
};

export const sendChatComposerTextMessage = (callback = () => {}) => {
  const state = store.getState();
  const serviceProviderId = selectors.serviceProviderId(state);
  const burstActionId = selectors.burstActionId(state);
  const actionPipelineLeadId = selectors.actionPipelineLeadId(state);
  const templateId = selectors.template(state);
  const composerPhone = state.leadModal.composerPhone;
  const activeLeadId = selectors.activeLeadId(state);
  postTextMessage(
    {
      contactDetailId: composerPhone.contactDetailId,
      contactId: composerPhone.contactId,
      serviceProviderId,
      leadId: activeLeadId,
      message: composerPhone.message,
      trackedPhoneId: composerPhone.fromId,
      fileIds: composerPhone.fileIds,
    },
    () => {
      autoMarkEventAsRead();
      setQuery({ type: null, template: null });
      triggerActionCompleted('text_template_id', { burstActionId, actionPipelineLeadId, templateId });
      action('leadModalPatchComposerPhone', {
        message: '',
        fileIds: [],
      });
      callback();
    }
  );
};

export const sendChatComposerEmailMessage = (callback = () => {}) => {
  const state = store.getState();
  const replyTo = selectors.replyTo(state);
  const serviceProviderId = selectors.serviceProviderId(state);
  const activeLeadId = selectors.activeLeadId(state);
  const composerEmail = state.leadModal.composerEmail;
  const burstActionId = selectors.burstActionId(state);
  const actionPipelineLeadId = selectors.actionPipelineLeadId(state);
  const templateId = selectors.template(state);
  const activeLead = selectors.activeLead(state);
  const pipelineLeads = (activeLead || {}).pipeline_leads;
  const activePipelineLeadServiceLocationId = (pipelineLeads || []).find((n) => n.status_id === '1');
  const payload = {
    ...composerEmail,
    serviceProviderId,
    ...(activePipelineLeadServiceLocationId && activePipelineLeadServiceLocationId.service_location_id ? { serviceLocationId: activePipelineLeadServiceLocationId.service_location_id } : {}),
    leadId: activeLeadId,
    messageHtml: formatEmailMessage(composerEmail.message),
    replyToMessageId: replyTo,
  };
  postEmail(payload, () => {
    autoMarkEventAsRead();
    setQuery({ type: null, replyTo: null, template: null });
    triggerActionCompleted('email_template_id', { burstActionId, actionPipelineLeadId, templateId });
    action('RESET_COMPOSER_EMAIL');
    if (payload.email_id) {
      action('DELETE_DRAFT', { emailId: payload.email_id });
    }
    callback();
  });
};

export const sendChatComposerPhoneCall = () => {
  const state = store.getState();

  const activeLeadId = selectors.activeLeadId(state);
  const serviceProviderId = selectors.serviceProviderId(state);
  const composerPhone = state.leadModal.composerPhone;

  postPhoneCall({
    leadId: activeLeadId,
    serviceProviderId: serviceProviderId,
    contactId: composerPhone.contactId,
    note: composerPhone.note,
    contactDetailId: composerPhone.contactDetailId,
    fromDetailId: composerPhone.fromId,
    manual: composerPhone.manual,
    callback: () => {
      autoMarkEventAsRead();
      action('leadModalPatchComposerPhone', {
        note: '',
        manual: false,
      });
      setQuery({ type: null });
    },
  });
};

export const sendChatComposerTodo = (callback = () => {}) => {
  const state = store.getState();
  const formState = selectors.boundFormStateById('todosComposer')(state);
  postTodo(formState, () => {
    setQuery({ type: null });
    callback();
  });
};

export const sendChatComposerNote = (callback = () => {}) => {
  const state = store.getState();

  const serviceProviderId = selectors.serviceProviderId(state);
  const activeLeadId = selectors.activeLeadId(state);
  const formState = selectors.boundFormStateById('noteComposer')(state);

  postNote(activeLeadId, serviceProviderId, formState.note, () => {
    setQuery({ type: null });
    callback();
  });
};

export const sendChatComposerReviewLoop = (callback = () => {}) => {
  const state = store.getState();

  const formState = selectors.boundFormStateById('reviewLoopComposer')(state);
  const serviceProviderId = selectors.serviceProviderId(state);
  const leadLocationId = (selectors.activeLead(state) || {}).service_location_id;
  const activeLeadId = selectors.activeLeadId(state);
  const platform = (selectors.serviceProviderPlatformRegistrations(state) || []).filter((n) => n.platform_code === 'reviewloop').find((n) => n.service_location_id === leadLocationId) || {};
  postReviewLoopText({
    contactDetailId: formState.contact_detail_id,
    contactId: formState.contact_id,
    message: formState.message,
    serviceProviderId: serviceProviderId,
    leadId: activeLeadId,
    platformRegistrationId: platform.id || null,
    callback: () => {
      setQuery({ type: null });
      callback();
    },
  });
};

export const sendChatComposerInstagram = (callback = () => {}) => {
  const state = store.getState();
  const composerPhone = state.leadModal.composerPhone;
  const serviceProviderId = selectors.serviceProviderId(state);
  const activeLeadId = selectors.activeLeadId(state);
  const chatHistory = selectors.chatMessages(state);
  const message = chatHistory.find((n) => (n.platform || {}).code === 'instagram');
  postFacebookMessengerMessage({
    serviceProviderId,
    message: composerPhone.message,
    platformRegistrationId: composerPhone.platformRegistrationId,
    serviceLocationId: message.service_location_id,
    threadId: message.thread_id,
    leadId: activeLeadId,
    callback: () => {
      setQuery({ type: null });
      action('leadModalPatchComposerPhone', {
        message: '',
        platformRegistrationId: null,
      });
      callback();
    },
  });
};

export const sendChatComposerFacebookMessenger = (callback = () => {}) => {
  const state = store.getState();
  const composerPhone = state.leadModal.composerPhone;
  const serviceProviderId = selectors.serviceProviderId(state);
  const activeLeadId = selectors.activeLeadId(state);
  const chatHistory = selectors.chatMessages(state);
  const message = chatHistory.find((n) => (n.platform || {}).code === 'facebookmessenger');
  postFacebookMessengerMessage({
    serviceProviderId,
    message: composerPhone.message,
    platformRegistrationId: composerPhone.platformRegistrationId,
    serviceLocationId: message.service_location_id,
    threadId: message.thread_id,
    leadId: activeLeadId,
    callback: () => {
      setQuery({ type: null });
      action('leadModalPatchComposerPhone', {
        message: '',
        platformRegistrationId: null,
      });
      callback();
    },
  });
};

export const sendChatComposerIntegrationLeadSync = ({ method, callback }) => {
  const state = store.getState();
  const activeComposerType = selectors.activeComposerType(state);
  const activeIntegration = ((state.currentServiceProvider || {}).platformRegistrations || []).find((el) => el.id === activeComposerType.integration_id);
  const activeLead = selectors.activeLead(state) || {};
  setQuery({ type: null });
  method(
    {
      lead_id: activeLead.id,
      platform_registration_id: activeIntegration.id,
      service_provider_id: activeIntegration.service_provider_id,
    },
    callback
  );
};

export const sendChatComposerFourthDimensionLead = (callback = () => {}) => {
  sendChatComposerIntegrationLeadSync({ method: postFourthDimensionLead, callback });
};

export const sendChatComposerEmaLead = (callback = () => {}) => {
  sendChatComposerIntegrationLeadSync({ method: postEmaLead, callback });
};

export const sendChatComposerPatientNowLead = (callback = () => {}) => {
  sendChatComposerIntegrationLeadSync({ method: postPatientNowLead, callback });
};

export const sendChatComposerNextechLead = (callback = () => {}) => {
  sendChatComposerIntegrationLeadSync({ method: postNextechLead, callback });
};

export const sendChatComposerEnvisionLead = (callback = () => {}) => {
  sendChatComposerIntegrationLeadSync({ method: postEnvisionLead, callback });
};

export const sendChatComposerIntakeQLead = (callback = () => {}) => {
  sendChatComposerIntegrationLeadSync({ method: postIntakeQLead, callback });
};
